import { Card, Table, Button, Col } from 'react-bootstrap';
import { useState } from 'react';
import { formatDate, formatTier } from '../../utils/formatters';

const TierConfigCard = ({ title, tiers, state, onEdit, onAdd }) => {
  const isWA = state === 'WA';
  const isOR = state === 'OR';

  return (
    <Card className="mb-4">
      <Card.Header className="d-flex justify-content-between">
        <Col md={10} className="d-flex align-items-center">
          <h3 className="mb-0">{title}</h3>
        </Col>
        <Col md={2} className="d-flex justify-content-end">
          <Button
            variant="primary"
            size="sm"
            onClick={onAdd}
            title="Add New Tier"
          >
            + Add New Tier
          </Button>
        </Col>
      </Card.Header>

      <Card.Body>
        <div className="table-responsive">
          <Table striped bordered hover className="mb-0">
            <thead>
              <tr>
                <th className="text-center">Tier</th>
                <th className="text-center">Energy Discount</th>
                <th className="text-center">Arrearage</th>
                {isWA && <th className="text-center">AMI Max</th>}
                <th className="text-center">FPL Max</th>
                {isOR && <th className="text-center">SMI Max</th>}
                <th className="text-center">Effective Date</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>

            <tbody>
              {tiers?.map((tier) => {
                const upcoming = tier.upcomingTier;

                const displayTier = upcoming ?? tier;

                return (
                  <tr key={tier.id}>
                    {/* Tier */}
                    <td className="text-center align-middle">
                      <strong className={upcoming ? 'text-success' : undefined}>
                        {formatTier(displayTier.state, displayTier.tier)}
                      </strong>
                    </td>

                    {/* Energy Discount */}
                    <td className="text-center align-middle">
                      {tier.energyDiscount}%
                      {upcoming && upcoming.energyDiscount !== tier.energyDiscount && (
                        <div className="text-success fw-bold">
                          {upcoming.energyDiscount}%
                        </div>
                      )}
                    </td>

                    {/* Arrearage */}
                    <td className="text-center align-middle">
                      {tier.arrearage}%
                      {upcoming && upcoming.arrearage !== tier.arrearage && (
                        <div className="text-success fw-bold">
                          {upcoming.arrearage}%
                        </div>
                      )}
                    </td>

                    {/* AMI Max (WA only) */}
                    {isWA && (
                      <td className="text-center align-middle">
                        {tier.amiMax}%
                        {upcoming && upcoming.amiMax !== tier.amiMax && (
                          <div className="text-success fw-bold">
                            {upcoming.amiMax}%
                          </div>
                        )}
                      </td>
                    )}

                    {/* FPL Max */}
                    <td className="text-center align-middle">
                      {tier.fplMax}%
                      {upcoming && upcoming.fplMax !== tier.fplMax && (
                        <div className="text-success fw-bold">
                          {upcoming.fplMax}%
                        </div>
                      )}
                    </td>

                    {/* SMI Max (OR only) */}
                    {isOR && (
                      <td className="text-center align-middle">
                        {tier.smiMax}%
                        {upcoming && upcoming.smiMax !== tier.smiMax && (
                          <div className="text-success fw-bold">
                            {upcoming.smiMax}%
                          </div>
                        )}
                      </td>
                    )}

                    {/* Effective Date */}
                    <td className="text-center align-middle">
                      {formatDate(tier.effectiveDate)}
                      {upcoming && (
                        <div className="text-success fw-bold">
                          {formatDate(upcoming.effectiveDate)}
                        </div>
                      )}
                    </td>

                    {/* Actions */}
                    <td className="text-center align-middle">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => onEdit(tier)}
                        title="Edit Tier"
                      >
                        Edit
                      </Button>
                    </td>
                  </tr>
                );
              })}

              {!tiers?.length && (
                <tr>
                  <td
                    colSpan={7}
                    className="text-center text-muted"
                  >
                    No tiers configured.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default TierConfigCard;